export interface IMemberData {
  id: string;
  count: number;
  score: number;
  tokens: any[];
  channels: any[];
  moodData: { positive: number; neutral: number; negative: number; total: number };
}

export interface IChannelData {
  id: string;
  count: number;
  score: number;
  tokens: any[];
  members: any[];
  moodData: { positive: number; neutral: number; negative: number; total: number };
}

export interface IDataStore {
  channelData: IChannelData[];
  data: any[];
  score: number;
  timeData: number[];
  timeDataArray: any[][];
  memberData: IMemberData[];
  moodData: { positive: number; neutral: number; negative: number; total: number };
}

export const dataStore = {
  channelData: [],
  data: [],
  score: 0.5,
  timeData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  timeDataArray: [[], [], [], [], [], [], [], [], [], []],
  memberData: [],
  moodData: { positive: 0, neutral: 0, negative: 0, total: 0 },
};
